export default "__VITE_ASSET__0c6e5b55__"